const NS = 'VenueActions';

export enum VenueActionNames {
  VENUE_CHANGE = 'venue-change', // no params to callback
  VENUE_LOADED = 'venue-loaded', // no params to callback
  RELOAD_NEEDED = 'reload-needed',
}

class VenueActions {

  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  venueAction(name: VenueActionNames, payload?: any) {
    this.$rootScope.$broadcast(name, payload);
  }

  handleVenueAction(name: VenueActionNames, callback: () => void): () => void {
    if (!name) {
      console.warn(NS, "you need to specify a valid VenueActionNames", name);
      return () => {};// returns a no op
    }

    // returns the "unlisten" handler
    return this.$rootScope.$on(name, (evt: any, payload?: any) => {
      callback();
    });
  }

}

// singleton
const instance = new VenueActions();
export default instance as VenueActions;
